import LogRecord, { DefaultMonitorOptions } from "./logRecord";
import ErrorCatch from "./errorCatch";
import eventEmitter from "./event-emitter";
import LogUpload from "./logUpload";
import { v1 as uuidv1 } from "uuid";
/**
 * @description: Class - 监控
 * @return {*}
 */
class Monitor {
  static errorCatch;
  static logRecord;
  static logUpload;
  static initOptions;

  constructor() {
    throw new Error("不需要对 Monitor 实例化。");
  }

  /**
   * @description: 初始化
   * @param {*} options
   * @example
   *    // options 参数示例
   *    {
   *       logUpload: {
   *         projectCode: "idt-monitor",
   *         enable: false,
   *         environment: "PORD",
   *         protocol: "https",
   *         intervalCollect: {
   *           enable: false,
   *           collectTime: 60,
   *         },
   *       },
   *       logRecord: {
   *         dbName: "Idt-Monitor-DB",
   *       },
   *       errorCatch: {
   *         enable: true,
   *         useLog: true,
   *         directUpload: false,
   *         debug: false,
   *       },
   *     };
   */
  static init(options = {}) {
    const opts = _mergeOptions(DefaultMonitorOptions, options);
    this.initOptions = opts;
    const { logRecord, logUpload, errorCatch } = opts;

    // 初始化
    this.#_generateUserFlag();

    this.#_initLogRecord(logRecord);
    this.#_initLogUpload(logUpload);
    this.#_initErrorCatch(errorCatch);

    this._initStorageHandler();
    this._initLogRecordCatchErrorHandler();
  }

  static #_initLogRecord(logRecordOpt) {
    this.logRecord = LogRecord.getInstance(logRecordOpt);
  }

  static #_initLogUpload(logUploadOpt) {
    this.logUpload = LogUpload.getInstance(logUploadOpt);
  }

  /** 初始化存储钩子，当浏览器存储达到临界值时，自动上传所有数据，并清理存储空间 */
  static _initStorageHandler() {
    if (this.logRecord && this.logUpload.initOptions.enable) {
      eventEmitter.addListener("LogRecord_QuotaExceededError_Storage", () => {
        Monitor.logRecord.getEstimatedQuota().then(({ quota, usage }) => {
          if (quota === usage) {
            Monitor.logUpload.directUploadOne({
              eventDetail: `Quota: ${quota}; Usage: ${usage}`,
              eventLevel: "warn",
              eventType: "LOCAL_INFO",
            });
            Monitor.logUpload.uploadAll();
            Monitor.logRecord.clearLogTable();
          }
        });
      });
    }
  }

  static _initLogRecordCatchErrorHandler() {
    eventEmitter.addListener("LogRecord_Error_Add", (data, errMsg) => {
      if (this.logUpload.initOptions.enable) {
        this.logUpload.directUploadOne({
          eventLevel: "error",
          eventType: "LOCAL_INFO",
          eventDetail: errMsg,
        });
        this.logUpload.directUploadOne(data);
      }
    });
  }

  static #_initErrorCatch(errorCatchOpt) {
    const { enable, useLog, directUpload, debug } = errorCatchOpt;
    let callback = null;

    if (useLog && this.logRecord) {
      callback = (data) => {
        this.logRecord.addRecord({
          eventType: "异常捕获",
          eventDetail: JSON.stringify(data),
          eventLevel: "error",
        });
      };
    }
    if (useLog && directUpload && this.logUpload) {
      callback = (data) => {
        this.logUpload.directUploadOne({
          eventType: "异常捕获",
          eventDetail: JSON.stringify(data),
          eventLevel: "error",
        });
      };
    }
    this.errorCatch = ErrorCatch.getInstance({
      enable,
      callback,
      debug,
    });
  }

  /**
   * @description: 检查用户是否存在唯一标识ID，没有则生成ID，并保存在LocalStorage
   * @return {*}
   */
  static #_generateUserFlag() {
    const userFlag = localStorage.getItem("Idt-UserFlag");
    if (!userFlag) localStorage.setItem("Idt-UserFlag", uuidv1());
  }
}

function _mergeOptions(origin, options) {
  const originKeys = Object.keys(origin);
  const optionsKey = Object.keys(options);
  const mergeKeys = [];
  const opts = {};

  // 填充没有修改的默认选项
  originKeys.forEach((key) => {
    if (optionsKey.indexOf(key) !== -1) mergeKeys.push(key);
    else opts[key] = origin[key];
  });

  // 对有修改的设置进行递归赋值处理
  mergeKeys.forEach((key) => {
    if (origin[key] instanceof Object) {
      opts[key] = _mergeOptions(origin[key], options[key]);
    } else {
      opts[key] = options[key];
    }
  });

  return opts;
}

export default Monitor;
